<div
        copoVirtualScroller
        [dataId]="dataId"
        #scroller="copoVirtualScroller"
        (moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
        class="copo-no-user-select sidenav-content copo-order-tracking-block"
        @routeAnimation
        cdkScrollable>
	<div class="order-tracking-list-title" translate>search.invoices</div>
	<div class="order-tracking-grid copo-container">
		<div *ngFor="let document of scroller.list" class="card-block">
				<div class="card-header">
					<div class="card-header-left">
						<mat-icon svgIcon="icon_invoice" class="header-margin-right"></mat-icon>
						<span class="header-margin-right overflow-wrap">{{document.typeDescription ? document.typeDescription :
							UNDERSCORE}}</span>
					</div>
					<div class="card-container-link">
						<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
							type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
							<mat-icon svgIcon="md:eye"></mat-icon>
						</a>
						<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
							type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
							<mat-icon svgIcon="md:download"></mat-icon>
						</a>
					</div>
				</div>
				<div class="card-content">
					<div class="content-grid-mobile text-overflow-ellipsis">
						<div class="card-container-column text-overflow-ellipsis">
							<span class="card-content-label" translate>commercial-documents.invoice-number</span>
							<a class="card-header-value"
								[routerLink]="['/commercial-documents/cards/invoice-card', document.id]">
								{{ document.name ? document.name : UNDERSCORE}}
							</a>
						</div>
						<div class="card-container-column">
							<div class="card-content-label" translate>commercial-documents.invoice-type</div>
							<div class="overflow-wrap">{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
						</div>
						<div class="card-header-right">
							<mat-icon svgIcon="calendar" class="header-margin-right grey-icon"></mat-icon>
							<div class="card-container-column">
								<span class="card-content-label" translate>datacenter-filter.creation-date</span>
								<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
							</div>
						</div>
						<div class="card-container-column">
							<span class="card-content-label" translate>commercial-documents.customer-order-number</span>
							<span class="overflow-wrap" *ngFor="let docLine of document.documentLines; let i = index">
								<span *ngIf="i < 1">
									{{docLine.customerOrderReference ? docLine.customerOrderReference : UNDERSCORE}}
								</span>
							</span>
						</div>
						<div>
							<div class="card-content-label" translate>commercial-documents.batch-number</div>
							<div *ngFor="let docLine of document.documentLines; let i = index">
								<div *ngIf="i < 3">
									<span>
										{{ docLine.batchNumber ? docLine.batchNumber : UNDERSCORE}}
									</span>
								</div>
							</div>
						</div>
							<div>
								<div class="card-content-label" translate>commercial-documents.mill</div>
								<div *ngFor="let docLine of document.documentLines; let i = index">
									<div *ngIf="i < 3">
										<span class="order-weight-label">
											{{ docLine.millDescription ? docLine.millDescription : UNDERSCORE }}
										</span>
									</div>
								</div>
							</div>
						<div class="card-container-column">
							<div class="card-content-label" translate>commercial-documents.payment-due-to</div>
							<div>{{ document.paymentDueDate ? (document.paymentDueDate | copoDate:'date') : UNDERSCORE
								}}</div>
						</div>
						<div class="card-container-link-row">
							<span class="card-container-column bold-label"
								translate>commercial-documents.invoice-quantity</span>
							<div class="card-container-column">
								<span class="overflow-wrap label-orange-color">{{document.invoicedQuantity ?? EMPTYSPACE}}</span>
								<span
									class="overflow-wrap card-column-center label-orange-color">{{document.invoiceAmount
									| copoNumber:'amount'}} &nbsp; {{document.invoiceCurrency}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="card-container-column card-column-end">
					<div class="card-container-link">
						<a mat-button color="primary" (click)="redirectToBatchDatacenter(document)" [routerLink]="['/order-tracking/batch/datacenter']">
							<span translate>order.card.document.display.batches</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
						</a>
					</div>
					<div class="card-container-link">
						<a mat-button color="primary" (click)="redirectToOrderDatacenter(document)" [routerLink]="document.docNavigationLink">
							<span translate>commercial-documents.display-all-orders</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
						</a>
					</div>
				</div>
		</div>
	<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
	<div translate class="empty-page-text" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>
